<template>

  <!-- Box -->


  <div class="box">
    <!-- Logo -->
    <img
      src="@/assets/img/logo-habs.svg"
      alt="Habs+ Logo"
      class="box__logo animate__animated animate__flipInX"
    >
    <!-- Content -->
    <div class="box__content">
      <!-- Title -->
      <h2 v-if="title">
        {{ title }}
      </h2>
      <!-- Description -->
      <p
        v-if="description"
        :class="{ 'hide-mobile': !descriptionMobile }"
      >
        {{ description }}
      </p>
      <!-- Disclaimer (Hidden for now, not needed anymore) -->
      <!-- <p
        v-if="disclaimer"
        class="box__disclaimer"
        v-html="disclaimer"
      /> -->
      <!-- Slot -->
      <slot />
    </div>
  </div>
</template>

<script>

import settings from "@/mixins/settings";
export default {
  name: 'Box',
  mixins: [settings],
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    description: {
      type: String,
      required: false,
      default: null,
    },
    descriptionMobile: {
      type: Boolean,
      required: false,
      default: true,
    },
    disclaimer: {
      type: String,
      required: false,
      default: null,
    },
  },
}
</script>

<!--Make sure <style> are not scoped if you @extend components, make a cleaner global css -->
<style lang="scss">
@import "src/assets/scss/components/_box";
// General
.box {
  @extend %box;
}
</style>
